<script>
import {
    eventGroupState,
    isSelectedEventGroupLocked
} from "@app/store/eventGroupStore.svelte.js";
import {
    projectState
} from "@app/store/projectStore.svelte.js";
import {
    editorState
} from "@app/store/editorStore.svelte.js";
import {
    insertHistoryAction
} from "@app/store/historyStore.svelte.js";
import getAvgTimePerWord from "@cclib/functions/events/getAvgTimePerWord.js";
import shiftWordBack from "@cclib/functions/quill/shiftWordBack.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';

let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || eventGroupState[projectState.selected].selected[0] === 0 || isSelectedEventGroupLocked());

function shiftWordToPrevious() {
    try {
        if (!eventGroupState[projectState.selected]) return;
        if (eventGroupState[projectState.selected].selected.length === 0) return;
        if (eventGroupState[projectState.selected].selected[0] === 0) return;
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        eventGroupState[projectState.selected].selected = [eventGroupState[projectState.selected].selected[0]];

        let res = shiftWordBack(eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]-1], eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]], eventGroupState[projectState.selected].maxChars);

        /* Replace both events with plain objects. Imported events can be Event class instances, which $state does not proxy, so mutating .text would not re-render the adjacent event. */
        let events = eventGroupState[projectState.selected].events;
        let currentIndex = eventGroupState[projectState.selected].selected[0];
        events[currentIndex-1] = { ...events[currentIndex-1], text: res.event1.text };
        events[currentIndex] = { ...events[currentIndex], text: res.event2.text };

        if (window.quillEditor){
            let eventIndex = eventGroupState[projectState.selected].selected[0];
            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
            window.quillEditor.setContents(delta, "silent");
            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");
        }

        if (editorState.updateTimeOnEdit){
            let currentEvent = eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]];
            let lastEvent = eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]-1];

            if (currentEvent.start && currentEvent.end && lastEvent.start && lastEvent.end){
                let avgTimePerWord = getAvgTimePerWord(currentEvent);

                if (avgTimePerWord > 0 && avgTimePerWord !== Infinity && !isNaN(avgTimePerWord)) {
                    eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]-1].end += avgTimePerWord;
                    eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]].start += avgTimePerWord;
                }                                
            }
        }

        insertHistoryAction({
            name: "shift word", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            }, ],
        });
    } catch (err) {
        console.log(err, err.message);
    }
}
</script>

<li class="nav-item"  
    role="none" title={m.shift_word_back_title()}>
    <a class="nav-link"
       href="#!/"
       role="button"
       id="shift-word-back-btn"
       aria-label={m.shift_word_back_aria_label()}
       class:disabled={isDisabled}
       aria-disabled={isDisabled}
       onclick={shiftWordToPrevious}>
        <strong aria-hidden="true">w</strong>
        <sup aria-hidden="true"><i class="bi bi-arrow-up"></i></sup>
    </a>
</li>
